import ShopCrudController from "./shopCrud.controller";

const angular = require('angular');

export default angular.module('nomasvelloDashboardApp.shops.shopsCrud', [])
    .controller('ShopCrudController', ShopCrudController)
    .component('shopCrud', {
        template: require('./index.pug'),
        controller: 'ShopCrudController',
        controllerAs: 'sCrud',
        bindings: {
            service: '=',
            translations: '=',
            fields: '=?',
        },
        bindToController: true,
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/manager/shops/shopCrud/index.ts